export const API_URL = process.env.REACT_APP_DEV_URL || '';
export const JWT_KEY = process.env.REACT_APP_JWT_KEY || '';
